import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { useMemo } from "react";
import CloseIcon from "./components/CloseIcon.js";
import { rootClass } from "./constant.js";
import "./index.css";
function Tag(props) {
    const { type = 'default', color = 'grey', size = 'small', showCloseIcon = false, clickTag = false, icon, className, children, onClose, onClick, ...domProps } = props;
    const innerClassName = useMemo(()=>{
        if (clickTag) return classnames(rootClass, 'grey-default', 'clickTag', size, className);
        return classnames(rootClass, `${color}-${type}`, size, className);
    }, [
        className,
        color,
        type,
        size,
        clickTag
    ]);
    return /*#__PURE__*/ jsxs("span", {
        className: innerClassName,
        onClick: onClick,
        ...domProps,
        children: [
            icon && icon,
            children,
            showCloseIcon && /*#__PURE__*/ jsx(CloseIcon, {
                onClick: onClose,
                className: `${rootClass}__closeIcon`
            })
        ]
    });
}
export { Tag as default };
